import { parseString } from 'xml2js';
import { LogLevel } from '@msdyn365-commerce/retail-proxy/dist/interfaces/ITelemetry';
import { CartLine } from '@msdyn365-commerce/retail-proxy';

export type SelectedConfiguration = {
    Session: {
        Attribute: {
            $: {
                name: string;
                readableName: string;
                readableValue: string;
                value: string;
            };
        }[];
    };
};

export const getConfigurations = (xml: string) => {
    // INSSELECTEDCONFIGURATION
    let configuration = '';
    if (xml) {
        parseString(xml, (err: Error | null, result: SelectedConfiguration) => {
            if (err) {
                console.log(LogLevel.Error, err.message);

                return;
            }

            if (result && result.Session && result.Session.Attribute && result.Session.Attribute.length > 0) {
                result.Session.Attribute.map(com => {
                    // configuration += `${com.$.name}-`;

                    configuration += `${com.$.readableValue}-`;
                });
            }
        });
    }

    return configuration.slice(0, -1);
};

export const getExtensionPropertiesFromCartLine = (cartLine: CartLine, key: string, type: 'string' | 'number' = 'string') => {
    if (type === 'string') {
        return cartLine.ExtensionProperties?.find(prop => prop.Key === key)?.Value?.StringValue || '';
    } else {
        return cartLine.ExtensionProperties?.find(prop => prop.Key === key)?.Value?.DecimalValue?.toString() || '';
    }
};
